import React from 'react';
import { useTranslation } from '../i18n';
import ChatMessage from './ChatMessage';
import TypingIndicator from './TypingIndicator';

export default function ChatThread({
  chatContainerRef,
  messagesEndRef,
  conversation,
  isTyping,
  error,
  onHotelSelect,
  onImageClick,
  onExportPdf,
  onShareItinerary,
  onReportBug,
  copiedToClipboard,
  setCopiedToClipboard,
}) {
  const { t } = useTranslation();

  return (
    <div ref={chatContainerRef} className="chat-thread no-scrollbar">
      <div className="chat-date-badge">
        <span>{t('chat.today')}</span>
      </div>
      {error && <p className="error-message">{error}</p>}
      {conversation.length === 0 && !isTyping && (
        <div className="no-messages">
          <div className="no-messages-icon">💬</div>
          {t('chat.empty')}
        </div>
      )}
      {conversation.map((msg, index) => (
        <ChatMessage
          key={index}
          msg={msg}
          index={index}
          onHotelSelect={onHotelSelect}
          onImageClick={onImageClick}
          onExportPdf={onExportPdf}
          onShareItinerary={onShareItinerary}
          onReportBug={onReportBug}
          copiedToClipboard={copiedToClipboard}
          setCopiedToClipboard={setCopiedToClipboard}
        />
      ))}
      {isTyping && <TypingIndicator />}
      <div ref={messagesEndRef} />
    </div>
  );
}
